import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import {
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
  TextFieldProps,
} from '@mui/material';
import {useEffect} from 'react';
import useSound from 'use-sound';

import {useAppSelector} from '../../hooks/redux';
import {SOUNDS} from '../../utils/sounds';
type Props = TextFieldProps;

export const SoundSelect = (props: Props) => {
  const options = useAppSelector(({assets}) => assets.sound);
  const file = !props.value ? SOUNDS.alarm_1 : SOUNDS[`${props.value}`];
  const [playSound, exposedData] = useSound(file);

  useEffect(() => {
    return () => {
      exposedData.stop();
    };
  }, [exposedData.sound]);

  return (
    <TextField
      fullWidth
      label="Sound"
      {...props}
      value={props.value ?? ''}
      select
      SelectProps={{IconComponent: () => null}}
      InputProps={{
        endAdornment: exposedData.sound ? (
          <InputAdornment position="end">
            <IconButton onClick={() => playSound()}>
              <PlayCircleOutlineIcon />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    >
      {options.map((option) => (
        <MenuItem key={option.code ?? ''} value={option.code ?? ''}>
          {option.name}
        </MenuItem>
      ))}
    </TextField>
  );
};
